import React from 'react';
import { useBrand } from '../../contexts/BrandContext';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  intro?: string;
  /** 'cream' means the heading sits on a dark surface. */
  tone?: 'ink' | 'cream';
  align?: 'left' | 'center';
  className?: string;
  children?: React.ReactNode;
}
export function SectionHeading({
  eyebrow,
  title,
  intro,
  tone = 'ink',
  align = 'left',
  className = '',
  children
}: SectionHeadingProps) {
  const onDark = tone === 'cream';
  const {
    text
  } = useBrand();
  return <div className={`${align === 'center' ? 'mx-auto max-w-2xl text-center' : ''} ${className}`} data-id="element-313" data-mp="i6dggxldg4fl">
      {eyebrow && <p className={`text-[0.6875rem] uppercase tracking-label ${onDark ? 'text-copper' : 'text-brick'}`} data-id="element-314" data-mp="d6sh4m2ahu2c">
          {eyebrow}
        </p>}
      <h2 className={`mt-3 font-serif text-3xl font-bold leading-tight tracking-tight md:text-5xl ${onDark ? 'text-cream' : 'text-ink'}`} data-id="element-315" data-mp="47doph2kb9f7">
        {text(title)}
      </h2>
      {intro && <p className={`mt-5 max-w-xl text-base leading-relaxed ${align === 'center' ? 'mx-auto' : ''} ${onDark ? 'text-cream/70' : 'text-ink-soft'}`} data-id="element-316" data-mp="1ir9dpso5tixu">
          {text(intro)}
        </p>}
      {children}
    </div>;
}